import { render, staticRenderFns } from "./StandCreate.vue?vue&type=template&id=2395083e"
import script from "./StandCreate.vue?vue&type=script&lang=ts"
export * from "./StandCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports